module.exports = __webpack_public_path__ + "static/media/bredablick_forvaltning_icon.811a8cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bredablick_forvaltning_icon.png
// module id = 802
// module chunks = 0